import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormEdit = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormEdit' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M11.9955241,8.33576576 L15.4932862,11.8335278 L11.9955241,8.33576576 Z M17.5365751,7.79609426 C17.9262629,8.18578207 17.9321949,8.81165877 17.5321697,9.21168397 L10.0807224,16.6631313 L6,17.829052 L7.16592069,13.7483296 L14.617368,6.29688224 C15.0094888,5.90476144 15.6393004,5.89881957 16.0329577,6.29247691 L17.5365751,7.79609426 Z' />
  </StyledIcon>
);
